"use client"
import { useTheme } from "next-themes"
import { Toaster as Sonner, ToasterProps } from "sonner"

import { CheckmarkFilledIcon } from "../icons"

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group rounded-xl border-2"
      toastOptions={{
        classNames: {
          closeButton: '!ms-auto !static !transform-none !p-2 [&_svg]:!size-4 [&_svg]:!shrink-0 !size-8 !bg-border-disabled !border-none',
          toast: '!justify-end !flex-row-reverse',
          error: '!bg-base-white !border-error-500 !text-error-500 !border-2',
          success: '!bg-base-white !border-success-500 !text-success-500 !border-2',
          warning: '!bg-base-white !border-warning-500 !text-warning-500 !border-2',
          icon: '!order-1 !self-start !me-2 !mt-1 [&_svg]:!size-6',
          title: '!text-body-sm-semibold',
          description: '!text-body-xs !text-text-secondary',
        },
      }}
      icons={{
        info: <CheckmarkFilledIcon size={24} />,
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
        } as React.CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
